import $ from 'jquery';

$('.search-toggle').on('click', function (e) {
    e.preventDefault();

    $.magnificPopup.open({
        items: {
            src: '#search-popup'
        },
        fixedContentPos: true,
        type: 'inline',
    });

    $('#search-popup').find('.polygon').removeClass('polygon--animate')
    setTimeout(function () {
        $('#search-popup').find('.polygon').addClass('polygon--animate')
    },100)
})